<template>
  <MgdSidebarMenu v-if="user">
    <MgdSidebarMenuItem>
      <MgdDropdownMenu>
        <MgdDropdownMenuTrigger as-child>
          <MgdSidebarMenuButton
            size="lg"
            class="data-[state=open]:bg-accent cursor-pointer"
          >
            <MgdAvatar>
              <MgdAvatarFallback>{{ avatarFallback }}</MgdAvatarFallback>
            </MgdAvatar>
            <div class="grid flex-1 text-left text-sm leading-tight">
              <span class="truncate font-semibold">{{ user.displayName }}</span>
              <span class="truncate text-xs">{{ user.email }}</span>
            </div>
            <Icon name="lucide:chevrons-up-down" class="ml-auto size-4" />
          </MgdSidebarMenuButton>
        </MgdDropdownMenuTrigger>
        <MgdDropdownMenuContent
          class="w-[var(--reka-dropdown-menu-trigger-width)] min-w-56 rounded-lg"
          :side="isMobile ? 'bottom' : 'right'"
          align="end"
        >
          <MgdDropdownMenuLabel class="p-0 font-normal">
            <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
              <MgdAvatar>
                <MgdAvatarFallback>{{ avatarFallback }}</MgdAvatarFallback>
              </MgdAvatar>
              <div class="grid flex-1 text-left text-sm leading-tight">
                <span class="truncate font-semibold">{{
                  user.displayName
                }}</span>
                <span class="truncate text-xs">{{ user.email }}</span>
              </div>
            </div>
          </MgdDropdownMenuLabel>
          <MgdDropdownMenuSeparator />

          <MgdDropdownMenuGroup>
            <MgdDropdownMenuItem as-child>
              <NuxtLink to="/my-account" class="flex hover:cursor-pointer">
                <Icon name="lucide:user" /> My Account
              </NuxtLink>
            </MgdDropdownMenuItem>

            <MgdDropdownMenuItem as-child>
              <NuxtLink to="/privacy-policy" class="flex hover:cursor-pointer">
                <Icon name="lucide:shield-check" /> Privacy Policy
              </NuxtLink>
            </MgdDropdownMenuItem>
            <MgdDropdownMenuItem as-child>
              <NuxtLink
                to="/_auth/logout"
                external
                class="flex hover:cursor-pointer"
              >
                <Icon name="lucide:log-out" /> Log out
              </NuxtLink>
            </MgdDropdownMenuItem>
          </MgdDropdownMenuGroup>
        </MgdDropdownMenuContent>
      </MgdDropdownMenu>
    </MgdSidebarMenuItem>
  </MgdSidebarMenu>
</template>

<script setup lang="ts">
import { useSidebar } from "~/components/ui/sidebar";

const { user } = useAppSession();
const { isMobile } = useSidebar();
const avatarFallback = computed(() => {
  if (!user.value) return "";
  return user.value.displayName
    .split(" ")
    .slice(0, 2)
    .map((s) => s.substring(0, 1).toLocaleUpperCase())
    .join("");
});
</script>
